import React from 'react';
import {
  BackgroundExportStatus,
  BackgroundExportTypes,
} from 'further-types/background-exports';
import DownloadTray from './DownloadTray';

interface DownloadTrayContainerProps {
  iconColor?: string;
  borderColor?: string;
  backgroundExports: Array<{
    _id: string;
    exportType: BackgroundExportTypes;
    status: BackgroundExportStatus;
    createdAt?: Date;
    downloaded: boolean;
  }>;
  downloadBackgroundExport: (exportId: string) => void;
  Heading?: React.ReactNode;
}

const DownloadTrayContainer: React.FC<DownloadTrayContainerProps> = ({
  iconColor,
  borderColor,
  backgroundExports,
  downloadBackgroundExport,
  Heading,
}) => {
  if (
    backgroundExports.every(
      (backgroundExport) =>
        backgroundExport.downloaded ||
        backgroundExport.status === BackgroundExportStatus.Failed,
    )
  ) {
    return null;
  }

  return (
    <DownloadTray
      iconColor={iconColor}
      borderColor={borderColor}
      backgroundExports={backgroundExports}
      downloadBackgroundExport={downloadBackgroundExport}
      Heading={Heading}
    />
  );
};

export default DownloadTrayContainer;
